import { Owner } from '@app/dao/user/modals';

export type SimulationOwnerKind = 'person' | 'couple' | 'company';

export interface SimulationOwnerOption {
  ownerIds: number[];
  label: string;
  kind: SimulationOwnerKind;
}

const optionOf = (owner: Owner): SimulationOwnerOption => ({
  ownerIds: [owner.id],
  label: owner.label,
  kind: owner.relation === 'COMPANY' ? 'company' : 'person',
});

/**
 * Choix d'attribution d'une simulation : chaque membre du couple, le couple ensemble, puis les autres
 * propriétaires actifs (enfants, personnes morales).
 */
export function buildSimulationOwnerOptions(
  couple: { id: number }[],
  owners: Owner[],
): SimulationOwnerOption[] {
  const activeOwners = owners.filter(owner => !owner.endDate);
  const coupleOwners = couple
    .map(user => activeOwners.find(owner => owner.id === user.id))
    .filter(owner => !!owner);
  const otherOwners = activeOwners.filter(owner => !coupleOwners.includes(owner));

  const options = coupleOwners.map(optionOf);
  if (coupleOwners.length === 2) {
    options.push({
      ownerIds: coupleOwners.map(owner => owner.id),
      label: coupleOwners.map(owner => owner.label).join(' et '),
      kind: 'couple',
    });
  }
  return options.concat(otherOwners.map(optionOf));
}
